var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBuyers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 96,
    viewBox: "0 0 88 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#buyers_svg__filter0_d_511_5962)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    width: 80,
    height: 80,
    rx: 40,
    fill: "url(#buyers_svg__paint0_linear_511_5962)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "url(#buyers_svg__paint1_linear_511_5962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1988 47.1952L41.4444 49.4489C40.6618 50.0892 40.6618 51.1273 41.4444 51.7675C41.8357 52.0878 42.3484 52.2478 42.8613 52.2478C43.374 52.2478 43.887 52.0877 44.2782 51.7676L47.0326 49.514C47.8152 48.8737 47.8152 47.8355 47.0327 47.1953C46.2501 46.555 44.9814 46.555 44.1988 47.1952ZM55.9848 39.8709C55.2023 39.2305 53.9334 39.2305 53.1509 39.8709L47.6419 44.3782C46.8594 45.0184 46.8594 46.0566 47.6419 46.6968C48.0332 47.017 48.5461 47.1771 49.0589 47.1771C49.5717 47.1771 50.0846 47.017 50.4759 46.6968L55.9848 42.1895C56.7674 41.5493 56.7674 40.5111 55.9848 39.8709Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.56 55.1201H51.7394C51.804 55.0566 51.8682 54.9929 51.9322 54.9289L62.9288 43.9323C64.5168 42.3444 65.9879 40.5913 65.9999 38.5341C66.0119 36.4682 64.5554 34.7253 62.9796 33.1495L55.4521 25.6219L55.4503 25.6202L54.8504 25.0203C53.2812 23.451 51.5461 22 49.4913 22L49.466 22C47.4087 22.012 45.6557 23.4832 44.0676 25.0712L33.0712 36.0677C31.4832 37.6557 30.0121 39.4088 30.0001 41.4661C29.9881 43.5319 31.4446 45.2749 33.0203 46.8505L33.6202 47.4504L33.6218 47.452L41.1494 54.9797C41.1963 55.0266 41.2433 55.0734 41.2905 55.12H31.44C30.6447 55.12 30 55.7647 30 56.56C30 57.3553 30.6447 58 31.44 58H64.56C65.3553 58 66 57.3553 66 56.56C66 55.7647 65.3553 55.1201 64.56 55.1201ZM32.88 41.4828C32.8847 40.6821 33.5717 39.6401 35.1076 38.1042L46.1041 27.1076C47.6401 25.5717 48.682 24.8847 49.4827 24.8801H49.4909C50.207 24.8801 51.1134 25.4287 52.3914 26.6443L34.6443 44.3915C33.424 43.1087 32.8759 42.2003 32.88 41.4828ZM43.186 52.9433L36.6757 46.433L54.433 28.6757L60.9432 35.186C62.4533 36.696 63.1246 37.7234 63.12 38.5173C63.1153 39.3179 62.4283 40.36 60.8924 41.8959L49.8958 52.8925C48.3599 54.4284 47.3179 55.1154 46.5173 55.12L46.5091 55.1201C45.7164 55.1201 44.6908 54.4481 43.186 52.9433Z",
    fill: "url(#buyers_svg__paint2_linear_511_5962)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "buyers_svg__paint0_linear_511_5962",
    x1: 48,
    y1: 0,
    x2: 48,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5FDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "buyers_svg__paint1_linear_511_5962",
    x1: 48,
    y1: 0,
    x2: 29.5,
    y2: 72.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5FAF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "buyers_svg__paint2_linear_511_5962",
    x1: 48,
    y1: 22,
    x2: 48,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED415F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EBC7B"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "buyers_svg__filter0_d_511_5962",
    x: 0,
    y: 0,
    width: 88,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.908749 0 0 0 0 0.967881 0 0 0 0 0.956436 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_511_5962"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_511_5962",
    result: "shape"
  })))));
}

export default SvgBuyers;